"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importStar(require("../Button"));
var ConfirmAlert_1 = require("../ConfirmAlert");
var Input_1 = require("../Input");
var InputAlert_1 = __importDefault(require("../InputAlert"));
var Select_1 = __importDefault(require("../Select"));
var buildOptions = function (options, localization) {
    var optionsElements = [
        react_1.default.createElement("option", { value: "", key: "select_value_empty", style: { display: "none" } }, localization.notSelected),
    ];
    var defaultOptions = [];
    var otherOptions = [];
    options.forEach(function (option) {
        var mappedOption = (react_1.default.createElement("option", { key: "select_option_" + option.id, value: option.id }, option.name));
        if (option.default) {
            defaultOptions.push(mappedOption);
        }
        else {
            otherOptions.push(mappedOption);
        }
    });
    if (defaultOptions.length) {
        optionsElements.push(react_1.default.createElement("optgroup", { key: "select_group_default", label: localization.defaultGroup }, defaultOptions), react_1.default.createElement("optgroup", { key: "select_group_users", label: localization.usersGroup }, otherOptions));
    }
    else {
        optionsElements = optionsElements.concat(otherOptions);
    }
    return optionsElements;
};
exports.default = (function (props) {
    var _a = props.options, options = _a === void 0 ? [] : _a, onChange = props.onChange, onSave = props.onSave, onRemove = props.onRemove, _b = props.value, value = _b === void 0 ? "" : _b, localization = props.localization;
    var handleOnChange = function (e) { return onChange(e.target.value); };
    var handleOnSave = function () {
        if (value === "") {
            InputAlert_1.default({
                singleRow: true,
                message: localization.newDisplay,
                placeholder: localization.inputName,
                buttons: [
                    { id: "ok", label: localization.save, variant: Button_1.ButtonVariant.Primary },
                    { id: "cancel", label: localization.cancel },
                ],
                onClick: function (key, message) {
                    if (key === "ok") {
                        onSave(message);
                    }
                },
            });
        }
    };
    var handleOnRemove = function () {
        if (value !== "") {
            ConfirmAlert_1.confirmYesNo(localization.deleteMessage, function () { return onRemove(); }, {
                confirmButtonType: Button_1.ButtonVariant.SecondaryBlue,
                cancelButtonType: Button_1.ButtonVariant.Primary,
            });
        }
    };
    // tslint:disable-next-line:triple-equals
    var valueOption = options.find(function (option) { return option.id == value; });
    var showRemoveButton = false;
    if (valueOption && !valueOption.default) {
        showRemoveButton = true;
    }
    return (react_1.default.createElement("div", { className: "d-flex align-items-center mb-12" },
        react_1.default.createElement("div", { className: "mr-12 emankit__displaybar" },
            react_1.default.createElement(Select_1.default, { variant: Input_1.InputVariant.White, onChange: handleOnChange, value: value }, buildOptions(options, localization))),
        value === "" && (react_1.default.createElement(Button_1.default, { variant: Button_1.ButtonVariant.SecondaryWhite, className: "ml-12 mr-12", onClick: handleOnSave }, localization.saveDisplay)),
        showRemoveButton && (react_1.default.createElement(Button_1.default, { variant: Button_1.ButtonVariant.Dangerous, className: "ml-12", onClick: handleOnRemove }, localization.removeDisplay))));
});
//# sourceMappingURL=index.js.map